import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import store from '@/store'

export default function useRolesList() {
  const toast = useToast()

  const roles = ref([])
  const loadingRoles = ref(false)

  const fetchRoles = () => {
    loadingRoles.value = true
    store
      .dispatch('roles/fetchRoles')
      .then(result => {
        loadingRoles.value = false
        roles.value = result
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching Roles list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  return {
    roles,
    loadingRoles,

    fetchRoles,
  }
}
